// @ts-nocheck
import { WorkflowStepsPanel } from './WorkflowStepsPanel';
import { Card } from './WorkflowFormPrimitives';

const noop = () => {};

/**
 * Left workflow rail + scrollable content card (same chrome as Overview /company).
 */
export function WorkflowStepBody({
  formData,
  selectedStepId,
  setSelectedStepId,
  parachuteSubId,
  setParachuteSubId,
  parachuteEquitySubId,
  setParachuteEquitySubId,
  parachuteExpanded,
  setParachuteExpanded,
  documentsSubId,
  setDocumentsSubId = noop,
  documentsExpanded,
  setDocumentsExpanded = noop,
  /** Overview-only: run before sidebar step changes so edits are not lost (routed pages use navigateTo instead). */
  persistBeforeNavigate,
  children,
}) {
  return (
    <div className="flex min-h-0 flex-col gap-4 md:flex-row md:items-start md:gap-4 lg:gap-5 xl:gap-6">
      <WorkflowStepsPanel
        formData={formData}
        selectedStepId={selectedStepId}
        setSelectedStepId={setSelectedStepId}
        parachuteSubId={parachuteSubId}
        setParachuteSubId={setParachuteSubId}
        parachuteEquitySubId={parachuteEquitySubId}
        setParachuteEquitySubId={setParachuteEquitySubId}
        parachuteExpanded={parachuteExpanded}
        setParachuteExpanded={setParachuteExpanded}
        documentsSubId={documentsSubId}
        setDocumentsSubId={setDocumentsSubId}
        documentsExpanded={documentsExpanded}
        setDocumentsExpanded={setDocumentsExpanded}
        persistBeforeNavigate={persistBeforeNavigate}
      />
      <div className="min-h-0 min-w-0 flex-1 overflow-auto">
        <Card className="w-full min-w-0 p-5 text-xs sm:p-6">{children}</Card>
      </div>
    </div>
  );
}
